import { t as translateDate } from './translate-date.js';
import './index2.js';

/*
 * Thelis
 */
function factory({ window, document, thn }) {

  const engine = {};

  engine._isVersion2 = function () {
    return !!(document.querySelector('thr-root'));
  };

  /**
     * @memberOf module:bs_115
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      thn.domReady().then(function () {

        let aux;

        aux = window.Core && window.Core.LANGUAGE;

        if (aux && ctx.langs.test(aux)) {
          resolve(aux);
          return;
        }

        aux = ctx.getHtmlLang({ attributes: ['lang', 'language'] });

        if (aux && ctx.langs.test(aux)) {
          resolve(aux);
          return;
        }

        reject('no_language');
      });

    });
  };

  /**
     * @memberOf module:bs_115
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = function onStateChange(ctx) {
    setTimeout(function () {
      thn.pageCheck();
    }, 600);
  };

  /**
     * @memberOf module:bs_115
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    if (engine._isVersion2()) { // Version 2
      if (!document.querySelector) { return; }

      const rootEl = document.querySelector('thr-search-results');

      thn.thelisLoadingChecker = function thnThelisLoadingChecker() {
        return !!(rootEl.querySelector('.thr-search-in-progress'));
      };

      if (rootEl && !thn.thelisObserver) {
        // Initial state
        thn.data.thelisLoading = thn.thelisLoadingChecker();

        thn.thelisObserver = thn.debounce(function thnThelisObserver() {
          if (thn.thelisLoadingChecker()) {
            // Loading just show
            thn.data.thelisLoading = true;

          } else if (thn.data.thelisLoading) {
            // Loading just hide
            thn.data.thelisLoading = false;

            // Reload PW
            thn.widgets.price.hide();
            setTimeout(() => thn.widgets.price.update(), 500);
          }
        }, 200);

        thn.observeDom(rootEl, thn.thelisObserver, {
          childList: true,
          subtree: false,
          characterData: false,
          attributes: false,
        });

        thn.pageUnload(function () {
          thn.stopObserveDom(rootEl, thn.thelisObserver);
          delete thn.thelisObserver;
          delete thn.data.thelisLoading;
          delete thn.thelisLoadingChecker;
        });
      }

    } else { // Version 1
      const loading = document.querySelector && document.querySelector('.thr-msg-searching');

      if (!loading) { // if the loading element does not exist, just recheck (initializing PW again) after a while
        this.logger.debug('Notice: the loading DOM element does not exist');

        setTimeout(() => ctx.widget.refresh(), 400);

      } else {
        // defined an observer function just once
        if (!thn.thelisObserver) {
          thn.thelisObserver = thn.debounce(function thnThelisObserver() {
            ctx.widget.logger.debug('*************** DOM Changed **************');

            if (!loading.classList.contains('active')) {
              thn.stopObserveDom(loading, thn.thelisObserver);
              thn.data.thelisObserverActive = false;

              // Wait a sec till everything finishes loading
              setTimeout(() => ctx.widget.update(), 2000);
            }
          }, 1000);
        }

        // define how to start thelis observation
        const startThelisObservation = function thnStartThelisObservation() {
          if (loading.classList.contains('active')
                        && !thn.data.thelisObserverActive) {

            ctx.widget.minimize();
            thn.data.thelisObserverActive = true;
            thn.observeDom(loading, thn.thelisObserver, {
              childList: false,
              subtree: false,
              characterData: false,
              attributes: true,
              attributeFilter: ['style', 'class'],
            });
            thn.pageUnload(function () {
              thn.stopObserveDom(loading, thn.thelisObserver);
            });
          }
        };

        // first, if still loading, straight observe
        startThelisObservation();

        // and setup click delegation for subsequent searches
        const undelegate = thn.delegate('click', '#thr-search-main-button', startThelisObservation);
        thn.pageUnload(function () {
          undelegate();
          delete thn.thelisObserver;
        });
      }
    }
  };

  /**
     * @memberOf module:bs_115
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {
    // begin=2017-09-12&end=2017-09-19&type=2&nb_pers=2

    const widgetData = {};

    if (!document.querySelector || !document.querySelectorAll) { return widgetData; }

    // Dates
    widgetData.dateBegin = thn.parseUrlParameter('begin').replace(/-/g, '/');
    widgetData.dateEnd = thn.parseUrlParameter('end').replace(/-/g, '/');

    // Guests
    widgetData.adults = parseInt(thn.parseUrlParameter('nb_pers'), 10) || 2;
    widgetData.children = 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    if (engine._isVersion2()) { // Version 2
      const loading = !!(document.querySelector('.thr-search-in-progress'));
      if (loading) { return widgetData; }

      const ngScope = window.angular && window.angular.element(document.querySelector('.thr-search-results')).scope();

      const ngProducts = ngScope && ngScope.$ctrl;
      const ngResult = ngProducts && ngProducts.result && ngProducts.result[0] && ngProducts.result[0].results;

      if (ngResult && Array.isArray(ngResult) && ngResult.length > 0) {
        const ngItems = ngResult[0] && ngResult[0].products;

        if (ngItems) {
          // Currency (from the first price)
          const firstPriceEl = document.querySelector('.thr-search-product-stay-price');
          if (firstPriceEl) {
            const priceText = [].reduce.call(firstPriceEl.childNodes, function (a, b) { return a + (b.nodeType === 3 ? b.textContent : ''); }, '');
            widgetData.currency = thn.getCurrencyCode((priceText.match(/[^\d\s,.]+/) || [])[0]);
          }

          // Price
          const noAvailabilityEl = document.querySelector('[class*=search-no-results]');
          if (noAvailabilityEl) {
            widgetData.noRooms = true;
            return widgetData;
          }
          ngItems.forEach((item) => {
            const roomInfo = item.stays && item.stays[0];
            if (roomInfo) {
              const price = parseFloat(roomInfo.price);
              if (price && (!widgetData.price || price < widgetData.price)) {
                // Dates
                widgetData.dateBegin = roomInfo.begin.replace(/-/g, '/');
                widgetData.dateEnd = roomInfo.end.replace(/-/g, '/');
                // Price
                widgetData.price = price;
              }
            }
          });
        }
      } else {
        widgetData.noRooms = true;
      }

    } else { // Version 1
      const loading = !!(document.querySelector('.thr-msg-searching.active'));
      if (loading) { return widgetData; }

      const ngPrices = [];

      const ngScope = window.angular && window.angular.element(document.querySelector('.thr-search-results > .thr-region')).scope();

      let ngCampsites = ngScope && ngScope.region;
      ngCampsites = ngCampsites && ngCampsites.campsites;

      const priceEl = document.querySelector('.thr-price span');
      widgetData.currency = priceEl && thn.getCurrencyCode((priceEl.textContent.match(/[^\d\s,.]+/) || [])[0]);

      if (ngCampsites) {
        Object.keys(ngCampsites).forEach(function (campsiteKey) {
          const ngCategories = ngCampsites[campsiteKey].categories;

          if (ngCategories) {
            Object.keys(ngCategories).forEach(function (categoryKey) {
              const ngStays = ngCategories[categoryKey].stays;

              if (ngStays) {
                Object.keys(ngStays).forEach(function (stayKey) {
                  const ngStay = ngStays[stayKey];

                  const price = parseFloat(ngStay.price);
                  if (price) {
                    ngPrices.push({
                      dateBegin: (ngStay.begin || '').replace(/-/g, '/'),
                      dateEnd: (ngStay.end || '').replace(/-/g, '/'),
                      price,
                    });
                  }
                });
              }
            });
          }
        });
      }

      if (ngPrices.length) {
        const minPrice = ngPrices.reduce(function (prev, curr) {
          return (curr.price < prev.price) ? curr : prev;
        });

        // Dates
        if (minPrice.dateBegin) { widgetData.dateBegin = minPrice.dateBegin; }
        if (minPrice.dateEnd) { widgetData.dateEnd = minPrice.dateEnd; }

        // Price
        widgetData.price = minPrice.price;

      } else { // DOM Alternative
        // Price
        const $prices = Array.from(document.querySelectorAll('.thr-price'));
        const noResults = Array.from(document.querySelectorAll('.thr-msg-no-results, .thr-search-no-results')).filter(thn.isVisible).length > 0;

        if ($prices.length) {
          if (!noResults) { // Rooms for the selected dates
            // Currency
            widgetData.currency = thn.getCurrencyCode(($prices[0].textContent.trim().match(/[^\d\s,.]+/) || [])[0]);

            const prices = $prices.filter(thn.isVisible).map(function (el) {
              return thn.parseNumber(el.textContent);
            });

            widgetData.price = Math.min(...prices);

          } else { // Avaible rooms for upcoming dates (No rooms for the selected dates)
            $prices.forEach(function (el) {
              const priceText = el.textContent;
              const price = thn.parseNumber(priceText);

              if (price && (!widgetData.price || price < widgetData.price)) {
                const parent = el.closest('.thr-stay');
                const dates = parent && parent.querySelectorAll('.thr-period');
                if (dates && dates.length === 2) {
                  // Dates
                  widgetData.dateBegin = translateDate(dates[0].textContent, thn.data.language || 'en');
                  widgetData.dateEnd = translateDate(dates[1].textContent, thn.data.language || 'en');

                  // Currency
                  widgetData.currency = thn.getCurrencyCode((priceText.match(/[^\d\s,.]+/) || [])[0]);

                  // Price
                  widgetData.price = price;
                }
              }
            });
          }

        } else if (noResults) {
          widgetData.noRooms = true;
        }
      }
    }

    if (widgetData.price) {
      // Price per night
      if (widgetData.dateBegin && widgetData.dateEnd) {
        widgetData.price = Math.round((widgetData.price / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd)) * 100) / 100;
      }

      widgetData.set = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_115
     * @this thn.widgets.booking
     * @see {@link Booking#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingObserveDom = function bookingObserveDom(ctx) {

    if (!ctx.widget.isSet()) {
      const el = document.querySelector && document.querySelector('.after');

      if (el) {
        const observer = thn.debounce(function thelisBookingObserver() {
          ctx.widget.logger.debug('*************** DOM Changed **************');

          if (ctx.widget.setData().isSet()) {
            thn.stopObserveDom(el, observer);
            ctx.widget.save();
          } else {
            thn.uploadPageHtml('booking-confirmed');
          }
        }, 400);

        thn.observeDom(el, observer);

        thn.pageUnload(function () {
          thn.stopObserveDom(el, observer);
        });
      }
    }
  };

  /**
     * @memberOf module:bs_115
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};

    // Get datalayer inside Conversion iframe
    let iframeDataLayer = document.querySelector('iframe[src*=Conversion], iframe[src*=conversion]');
    iframeDataLayer = iframeDataLayer && iframeDataLayer.contentWindow && iframeDataLayer.contentWindow.dataLayer;
    iframeDataLayer = iframeDataLayer && new thn.DataLayerHelper(iframeDataLayer || [], null, true);

    if (iframeDataLayer) {
      // Booking ID (datalayer)
      widgetData.bookingId = iframeDataLayer.get('ecommerce.purchase.actionField.id');

      // Occupancy not available

      // Price (Only available on the datalayer)
      widgetData.price = thn.parseNumber(iframeDataLayer.get('ecommerce.purchase.actionField.revenue')
                || thn.objectGet(iframeDataLayer, 'value', { first: false }) || (thn.objectGet(iframeDataLayer, 'items', { first: false }) || [])[0]?.price);
      // Thelis only operates in EUR (no way to obtain it dinamically)
      widgetData.currency = 'EUR';
    }

    // Booking ID (DOM)
    if (!widgetData.bookingId) {
      widgetData.bookingId = (document.querySelector('.thr-box-confirm-product-infos-reference > span') || {}).textContent;
    }

    // Dates (DOM)
    widgetData.dateBegin = ((document.querySelector('[class*=dates-duration] > span:nth-child(1)') || {}).textContent || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    widgetData.dateEnd = ((document.querySelector('[class*=dates-duration] > span:nth-child(2)') || {}).textContent || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');

    return widgetData;
  };

  return engine;

}

export { factory };
